import { ThemeType } from "src/styles/theme";
import styled, { css } from "styled-components";

export interface ButtonBaseProps extends React.ComponentPropsWithRef<"button"> {
  themeColor: keyof ThemeType["colors"];
  small?: boolean;
}

export default styled.button<ButtonBaseProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, themeColor }) => theme.colors[themeColor]};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 18px;
  line-height: 32px;
  width: fit-content;
  padding-left: 1em;
  padding-right: 1em;
  height: 48px;
  outline: none;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  position: relative;

  :disabled {
    cursor: auto;
  }

  ${({ small }) =>
    small &&
    css`
      width: 172px;
      height: 40px;
    `}
`;
